import { Component, OnInit } from '@angular/core';
import { fuseAnimations } from "@fuse/animations";
import { ActivatedRoute } from "@angular/router";
import { ParseService } from "../../../shared/common/parse/parse.service";
import { MatDialog } from "@angular/material/dialog";
import { Location } from "@angular/common";
import { SessionHandler } from 'app/shared/common/parse/session-handler';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'app-profile-view',
    templateUrl: './profile-view.component.html',
    styleUrls: ['./profile-view.component.scss'],
    animations: fuseAnimations
})

export class ProfileViewComponent implements OnInit {

    imageURL: string = "assets/images/avatars/profile.jpg";
    fileToUpload: File = null;
    proImage: any;
    genderLists: any;
    maritalStatusLists: any;
    religionLists: any;
    formErrors: any;
    about: any;
    userroles: any;
    userroles1: any;
    profileroles: any;
    profileDetails: any;
    instance: any;
    religionvalue: any;
    organisationLists: any;
    departmentLists: any;
    reportingtoLists: any;
    designationLists: any;
    starttimeLists: any;
    objectId = this.parseService.instance.User.current().id;
    hideDemo = true;
    hideProfile = true;
    hideBack = true;
    hideProfessional = true;
    hideExperience = true;
    hidePro = true;
    hideExp = true;
    firstname: String;
    lastname: String;
    profileImgId: any;
    profileValue: any;
    profId: any;
    profileId: any;
    userId = this.parseService.instance.User.current().id;
    hideProfileChange = false;
    empRole: any;
    tabTitle: string;

    constructor(
        private route: ActivatedRoute,
        private parseService: ParseService,
        public dialog: MatDialog,
        private _location: Location,
        private sessionHandler: SessionHandler,
        private storageConfiguration: StorageConfiguration,
        private queryInterface: QueryInterface,
        private spinner: NgxSpinnerService
    ) {

    }

    /*
    ** ==========================================================
    ** On Init
    ** ==========================================================
    */
    ngOnInit() {
        var user = this.parseService.instance.User.current().id;
        this.firstname = this.parseService.instance.User.current().get('firstName');
        this.lastname = this.parseService.instance.User.current().get('lastName');
        this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
        this.route.params.subscribe(params => {
            this.objectId = params["id"];
            if (this.objectId) {
                var user = new this.parseService.instance.Object("Profile");
                user.id = this.objectId;
                user.fetch().then(
                    res => {
                        this.firstname = res.get("firstName");
                        this.lastname = res.get("lastName");
                    },
                    err => { }
                ).catch(err => {
                    this.sessionHandler.handleParseError(err)
                });
            }
            if (this.objectId !== undefined) {
                if (user !== this.objectId) {
                    this.hideDemo = false;
                }
            } else {
                this.hideProfile = false;
                this.hideBack = false;
            }
        });
        this.getProfilePhotos();
    }

    /*
    ** ==========================================================
    ** Get Profile Photo
    ** ==========================================================
    */
    async getProfilePhotos() {
        await this.queryInterface.executeQuery(this.parseService, "User", [
            { condition: "equalTo", field: "objectId", value: this.userId }]).then(result => {
                const myObject = JSON.parse(JSON.stringify(result[0]));
                if (myObject.profile.objectId != this.objectId) {
                    this.hideProfileChange = true;
                }
            });
        await this.queryInterface.executeQuery(this.parseService, "Profile", [
            { condition: "equalTo", field: "objectId", value: this.objectId }]).then(result => {
                var results = result[0];
                let jsonText = JSON.stringify(results);
                let userProfile = JSON.parse(jsonText);
                this.profileValue = userProfile;
                this.profileImgId = this.profileValue.profileImageInfo.imageId;
                this.proImage = this.profileValue.profileImageInfo.url;
                this.spinner.hide();
            });
    }

    backlocation() {
        this._location.back();
    }

    selectedTabChange(event) {
        console.log('event',event)
        this.tabTitle = event.tab.textLabel;
    }
}
